import React from "react";
import VerticalSlider from "../../containers/VerticalSlider";

import CasinoGame1 from "./../../assets/images/sidebar-games/evolution.jpg";
import CasinoGame2 from "./../../assets/images/sidebar-games/baccarat.jpg";
import CasinoGame3 from "./../../assets/images/sidebar-games/andar-bahar.jpg";
import CasinoGame4 from "./../../assets/images/sidebar-games/sic-bo.jpg";
import CasinoGame5 from "./../../assets/images/sidebar-games/speed-roulette.jpg";
import CasinoGame6 from "./../../assets/images/sidebar-games/blackJack.jpg";
import CasinoGame7 from "./../../assets/images/sidebar-games/italian-roulette.jpg";
import CasinoGame8 from "./../../assets/images/sidebar-games/namaste-roulette.jpg";
import CasinoGame9 from "./../../assets/images/sidebar-games/lucky7.jpg";
import CasinoGame10 from "./../../assets/images/sidebar-games/cards32.jpg";

const RightBarCasino = () => {
  return (
    <>
      <div className="rightbarSec">
        <h6>LIVE CASINO GAMES</h6>
        <VerticalSlider />

        <div className="casino_games">
          <a href="/casino/evolution" className="">
            <img src={CasinoGame1} alt="Casino Game" loading="lazy" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
          <a href="/casino/ezugi/Baccarat" className="">
            <img src={CasinoGame2} alt="Casino Game" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
          <a href="/casino/ezg-andar-bahar" className="">
            <img src={CasinoGame3} alt="Casino Game" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
          <a href="/casino/ezg-sic-bo" className="">
            <img src={CasinoGame4} alt="Casino Game" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
          <a href="/casino/ezg-speed-roulette" className="">
            <img src={CasinoGame5} alt="Casino Game" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
          <a href="/casino/ezg-rumba-blackjack-4" className="">
            <img src={CasinoGame6} alt="Casino Game" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
          <a href="/casino/ezg-italian-roulette" className="">
            <img src={CasinoGame7} alt="Casino Game" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
          <a href="/casino/ezg-namaste-roulette" className="">
            <img src={CasinoGame8} alt="Casino Game" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
          <a href="/casino/ezg-lucky-7" className="">
            <img src={CasinoGame9} alt="Casino Game" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
          <a href="/casino/ezg-32-cards" className="">
            <img src={CasinoGame10} alt="Casino Game" />
            <div className="overlay">
              <div className="game_type">Play Now</div>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default RightBarCasino;
